import { render, staticRenderFns } from "./bookOutsWrapper.vue?vue&type=template&id=4601c26a&"
import script from "./bookOutsWrapper.vue?vue&type=script&lang=js&"
export * from "./bookOutsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./bookOutsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports